(function () {
  var captureInProgress = false;
  var cartMutationQueue = Promise.resolve();

  function oneValue(params, name) {
    var values = params.getAll(name);
    return values.length === 1 ? values[0] : null;
  }

  function isValidFbclid(value) {
    return typeof value === "string" && value.length > 0 && value.length <= 512 &&
      !/[\u0000-\u001F\u007F-\u009F]/.test(value);
  }

  function matchingContext(current, candidate) {
    try {
      var captured = new Date(candidate.captured_at);
      if ((candidate.version !== 1 && candidate.version !== 2) || candidate.platform !== "meta" ||
          candidate.affiliate !== current.affiliate ||
          !candidate.identifiers || candidate.identifiers.fbclid !== current.identifiers.fbclid ||
          typeof candidate.captured_at !== "string" ||
          !Number.isFinite(captured.getTime()) || captured.getTime() > Date.now()) {
        return null;
      }
      // Migrate version 1 without refreshing the click time or carrying over
      // campaign fields. Existing referral links need no new ad parameters.
      current.captured_at = candidate.captured_at;
      return current;
    } catch (_error) {
      return null;
    }
  }

  function matchingStoredContext(current) {
    try {
      var raw = localStorage.getItem("thr_meta_click_context");
      return raw ? matchingContext(current, JSON.parse(raw)) : null;
    } catch (_error) {
      return null;
    }
  }

  function currentMetaTuple() {
    var params = new URLSearchParams(window.location.search);
    var affiliateValue = oneValue(params, "ref");
    var fbclid = oneValue(params, "fbclid");
    if (affiliateValue === null || fbclid === null) {
      return null;
    }

    var affiliate = affiliateValue.trim().toLowerCase();
    if (!/^[A-Za-z0-9][A-Za-z0-9._-]{0,127}$/.test(affiliate) ||
        !isValidFbclid(fbclid)) {
      return null;
    }

    return {
      version: 2,
      platform: "meta",
      affiliate: affiliate,
      identifiers: { fbclid: fbclid }
    };
  }

  function storefrontRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function readMatchingCartContext(current) {
    return fetch(storefrontRoot() + "cart.js", {
      method: "GET",
      credentials: "same-origin"
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart.js failed with status " + response.status);
        return response.json();
      })
      .then(function (cart) {
        var raw = cart && cart.attributes && cart.attributes.thrivalist_meta_click;
        if (!raw) return null;
        try {
          return matchingContext(current, JSON.parse(raw));
        } catch (_error) {
          return null;
        }
      });
  }

  function resolveContext(current) {
    // A recreated cart can use the convenience cache. When that cache is
    // blocked or was independently cleared, consult the server cart before
    // assigning a new time so an old URL reload cannot refresh its click age.
    var stored = matchingStoredContext(current);
    if (stored) return Promise.resolve(stored);
    return readMatchingCartContext(current).then(function (cartContext) {
      if (cartContext) return cartContext;
      current.captured_at = new Date().toISOString();
      return current;
    });
  }

  function enqueueCartMutation(operation) {
    // Serialize capture and clear writes. If consent changes while a capture is
    // in flight, the denial clear is therefore guaranteed to execute after the
    // capture instead of being overtaken by its response.
    var result = cartMutationQueue.then(operation, operation);
    cartMutationQueue = result.catch(function () {});
    return result;
  }

  function updateCartContext(context) {
    return enqueueCartMutation(function () {
      var attributes = {
        fbclid: context.identifiers.fbclid,
        thrivalist_meta_click: JSON.stringify(context)
      };
      return fetch(storefrontRoot() + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attributes }),
        credentials: "same-origin"
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("cart/update.js failed with status " + response.status);
          }
          return response.json();
        });
    });
  }

  function startTracking() {
    if (captureInProgress) return;

    try {
      // Every authorization field comes from this URL. Never combine a new
      // visit with identifiers or ownership retained from an older visit.
      var current = currentMetaTuple();
      if (!current) return;
      captureInProgress = true;

      resolveContext(current)
        .then(function (context) {
          if (!trackingIsAllowed()) return clearTracking();
          return updateCartContext(context).then(function () {
            if (!trackingIsAllowed()) return clearTracking();
            // Local storage is only a convenience cache. Server authorization
            // comes from the complete context written in one cart update.
            try {
              localStorage.setItem("thr_fbclid", context.identifiers.fbclid);
              localStorage.setItem("thr_meta_click_context", JSON.stringify(context));
            } catch (_error) {
              console.error("Meta click convenience storage unavailable");
            }
            console.log("Meta click context saved to cart attributes");
          });
        })
        .catch(function (err) {
          console.error("Meta click capture failed", err);
        })
        .then(function () {
          captureInProgress = false;
        });
    } catch (err) {
      captureInProgress = false;
      console.error("Meta click capture script error", err);
    }
  }

  function clearTracking() {
    // Always retry the server clear on a denied page load. This also covers a
    // cart that still has context after browser storage was evicted or a prior
    // clear request failed.
    try {
      localStorage.removeItem("thr_fbclid");
      localStorage.removeItem("thr_meta_click_context");
    } catch (_error) {
      // Local storage is optional; clearing the server-side cart is primary.
    }
    return enqueueCartMutation(function () {
      return fetch(storefrontRoot() + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { fbclid: "", thrivalist_meta_click: "" }
        }),
        credentials: "same-origin"
      })
        .then(function (response) {
          if (!response.ok) throw new Error("cart context clear failed");
          return response.json();
        });
    }).catch(function () {
      console.error("Meta click context clear failed");
    });
  }

  function trackingIsAllowed() {
    try {
      if (!window.Shopify || !window.Shopify.customerPrivacy) return false;
      var privacy = window.Shopify.customerPrivacy;
      if (typeof privacy.marketingAllowed === "function" ||
          typeof privacy.saleOfDataAllowed === "function") {
        return typeof privacy.marketingAllowed === "function" &&
          typeof privacy.saleOfDataAllowed === "function" &&
          Boolean(privacy.marketingAllowed()) &&
          Boolean(privacy.saleOfDataAllowed());
      }
      return typeof privacy.userCanBeTracked === "function" &&
        typeof privacy.userDataCanBeSold === "function" &&
        Boolean(privacy.userCanBeTracked()) &&
        Boolean(privacy.userDataCanBeSold());
    } catch (_error) {
      return false;
    }
  }

  function startIfAllowed() {
    if (trackingIsAllowed()) startTracking();
    else clearTracking();
  }

  function handleConsentChange() {
    if (trackingIsAllowed()) startTracking();
    else clearTracking();
  }

  try {
    if (window.Shopify && window.Shopify.loadFeatures && !window.Shopify.customerPrivacy) {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
        if (error) clearTracking();
        else startIfAllowed();
      });
    } else {
      startIfAllowed();
    }
    document.addEventListener("visitorConsentCollected", handleConsentChange);
    // Retain compatibility with themes still using Shopify's historical
    // consent-tracking API while migrating to visitorConsentCollected.
    document.addEventListener("trackingConsentAccepted", startIfAllowed);
  } catch (err) {
    console.error("Meta click capture script initialization error", err);
    try {
      clearTracking();
    } catch (_clearError) {
      // The initialization error is already recorded; remain fail closed.
    }
  }
})();
